import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enLocale);

// Backend country names that don't match i18n-iso-countries' English names.
const COUNTRY_NAME_ALIASES: Record<string, string> = {
	'congo, democratic republic': 'CD',
	'korea, south': 'KR',
	micronesia: 'FM',
	moldova: 'MD',
	'viet nam': 'VN'
};

export const getCountryCode = (
	countryName: string | null | undefined
): string | undefined => {
	if (!countryName) return undefined;

	const trimmed = countryName.trim();
	if (!trimmed) return undefined;

	if (trimmed.length === 2 && countries.isValid(trimmed.toUpperCase())) {
		return trimmed.toUpperCase();
	}

	const code = countries.getAlpha2Code(trimmed, 'en');
	return code || COUNTRY_NAME_ALIASES[trimmed.toLowerCase()] || undefined;
};
